import BaseEntity from './BaseEntity';
import BranchCodeCoverage from './BranchCodeCoverage';
import Repository from './Repository';
export default class Dashboard extends BaseEntity {
    constructor(data, branchName) {
        super();
        this.repository = new Repository(this.parseProperty(data, 'repository'), this.parseProperty(data, 'commits'), this.parseProperty(data, 'commonIssues'), branchName, new BranchCodeCoverage(this.parseProperty(data, 'codeCoverage')));
    }
}
